import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-no-resellers-found-dialog',
    templateUrl: './no-resellers-found-dialog.html',
})
export class NoResellersFoundDialogComponent {

    public mainForm: FormGroup;
    public captchaUrl: string;
    public isIT: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<NoResellersFoundDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        public loc: LocalizationService)
    {
      this.isIT = this.loc.currLang() == "IT";
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/no-resellers-found-dialog/no-resellers-found-dialog.ts